import React, { useState } from "react";
import { Card, Button, Pagination, Spin, Empty, Row, Col } from "antd";
import { FileOutlined } from "@ant-design/icons";
import { BsBuildingsFill } from "react-icons/bs";
import usePersonnelDocumentService from "../../../services/usePersonnelDocumentService";
import { theme } from "../../../utils/theme";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes";

const DocumentManagement = () => {
  const navigate = useNavigate();

  const { useGetFirmsPersonnel, useGetAllFilesPersonnel } =
    usePersonnelDocumentService();

  const { data: firmsResponse, isLoading: isFirmsLoading } =
    useGetFirmsPersonnel();

  const firms = firmsResponse?.data || [];

  const goToUpdatePage = (firm) => {
    let path = `${PageRoutes.documentUpload}`;
    console.log("firm is", firm);
    navigate(path, {
      state: {
        companyName: firm.companyName,
        imageUrl: firm.imageUrl,
        firmId: firm.id,
      },
    });
  };

  if (isFirmsLoading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.headerContainer}>
        <div style={styles.headerTitle}>Başvurduğum Firmalar</div>
        <div style={styles.headerLine}></div>
      </div>

      {firms.length === 0 ? (
        <Empty description="Firma bulunamadı" />
      ) : (
        <Row gutter={[16, 16]}>
          {firms.map((firm) => (
            <Col xs={24} sm={12} md={8} key={firm.id}>
              <Card
                hoverable
                cover={
                  firm.imageUrl ? (
                    <img
                      alt={firm.companyName}
                      src={firm.imageUrl}
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                  ) : (
                    <div style={styles.placeholderIcon}>
                      <BsBuildingsFill size={64} color="#bfbfbf" />
                    </div>
                  )
                }>
                <Card.Meta
                  title={firm.companyName}
                  style={{ textAlign: "center", marginBottom: "16px" }}
                />
                <Button
                  type="primary"
                  icon={<FileOutlined />}
                  onClick={() => goToUpdatePage(firm)}
                  block>
                  Dökümanları Yönet
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default DocumentManagement;

const styles = {
  container: {
    background: "#fff",
    width: "90%",
    margin: "0 auto",
    padding: "24px",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 32,
    padding: "20px 0",
    borderBottom: "2px solid #f0f0f0",
  },
  headerTitle: {
    color: theme.primaryColor,
    marginBottom: 8,
    fontSize: "28px",
    fontWeight: "600",
    position: "relative",
  },
  headerLine: {
    width: "60px",
    height: "3px",
    backgroundColor: theme.primaryColor,
    borderRadius: "2px",
  },
  paginationContainer: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "center",
  },
  placeholderIcon: {
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
};
